import { appVersion, lastBuildDate } from 'src/consumer/services'
import { getApiDebugQueryConfig, resolveApiDomainConfig } from 'src/consumer/services/apiDomainConfig'

function getDisplayHost(url) {
  if (!url) {
    return 'not-set'
  }

  try {
    const parsed = new URL(url)
    return `${parsed.host}${parsed.pathname === '/' ? '' : parsed.pathname}`
  } catch {
    return url
  }
}

export default function ApiDebugStatusBadge({ debugMode = false, onExitDebugMode }) {
  const apiDomainConfig = resolveApiDomainConfig()
  const debugQueryConfig = getApiDebugQueryConfig()
  const hasStoredApiDeviation =
    Boolean(apiDomainConfig.storedDefaultApiBaseUrl) &&
    apiDomainConfig.storedDefaultApiBaseUrl !== apiDomainConfig.defaultApiBaseUrl
  const hasStoredPublicApiDeviation =
    Boolean(apiDomainConfig.storedPublicApiBaseUrl) &&
    apiDomainConfig.storedPublicApiBaseUrl !== apiDomainConfig.defaultPublicApiBaseUrl

  const shouldShow =
    debugMode ||
    debugQueryConfig.debugPanelRequested ||
    Boolean(apiDomainConfig.customApiBaseUrl) ||
    Boolean(apiDomainConfig.customPublicApiBaseUrl) ||
    hasStoredApiDeviation ||
    hasStoredPublicApiDeviation

  if (!shouldShow) {
    return null
  }

  const badgeTitle = debugMode
    ? 'Debug (mode on)'
    : apiDomainConfig.customApiBaseUrl || apiDomainConfig.customPublicApiBaseUrl
      ? 'Debug (active overrides)'
      : 'Debug (non-default API config)'

  return (
    <div
      style={{
        position: 'fixed',
        left: '12px',
        bottom: '12px',
        zIndex: 12000,
        maxWidth: 'min(360px, calc(100vw - 24px))',
        background: '#0f172a',
        color: '#f8fafc',
        borderRadius: '12px',
        padding: '10px 12px',
        boxShadow: '0 14px 36px rgba(15, 23, 42, 0.35)',
        fontSize: '12px',
        lineHeight: 1.45,
      }}
    >
      <div style={{ fontWeight: '700', marginBottom: '4px' }}>{badgeTitle}</div>
      <div style={{ marginBottom: '2px' }}>Version: {appVersion}</div>
      <div style={{ marginBottom: '6px' }}>Build: {lastBuildDate}</div>
      <div style={{ marginBottom: '2px' }}>
        API: {getDisplayHost(apiDomainConfig.effectiveApiBaseUrl)} ({apiDomainConfig.apiSource})
      </div>
      <div style={{ marginBottom: '8px' }}>
        Public: {getDisplayHost(apiDomainConfig.effectivePublicApiBaseUrl)} (
        {apiDomainConfig.publicApiSource})
      </div>
      <div style={{ marginBottom: debugMode ? '8px' : '0', opacity: 0.85 }}>
        Open `?nebula=dust` for the full API/version console.
      </div>
      {debugMode && (
        <button
          type="button"
          onClick={onExitDebugMode}
          style={{
            color: '#fff',
            background: '#dc2626',
            border: 'none',
            borderRadius: '8px',
            padding: '6px 10px',
            cursor: 'pointer',
          }}
        >
          Exit debug mode
        </button>
      )}
    </div>
  )
}
